import React from "react";

/* eslint-disable max-len */
export default function CommentIcon() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
		<path fill="#676767" d="M21,1.8H3.5c-1.2,0-2.2,1-2.2,2.2v19.7l4.4-4.4H21c1.2,0,2.2-1,2.2-2.2V4C23.2,2.8,22.2,1.8,21,1.8z
			M21,17.1H4.8l-1.3,1.3V4H21V17.1z M6.8,9.4H9v2.2H6.8V9.4z M15.6,9.4h2.2v2.2h-2.2V9.4z M11.2,9.4h2.2v2.2h-2.2V9.4z"/>
		</svg>
    );
}
